import { portalAPI } from 'store/api/portalAPI';
import { objectToQueryParams } from 'utils/linkUtil';

/** What a list's own endpoint answers a saved-view widget: one page of the list, or its totals. */
export type ListAnswer = Record<string, unknown>;

/** `size` asks a page endpoint for that many rows of its first page; a totals endpoint takes the filter alone. */
type ListRequest = { url: string; filter: string; size?: number };

/**
 * A saved-view widget's requests to the list it is built on. They go to the list's own endpoints as the viewer, so
 * the widget never shows more than the list would, under one name of their own: a list that fails or is closed to
 * the viewer is told in the widget's card.
 */
export const APISavedViewFigureSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getSavedViewAnswer: builder.query<ListAnswer, ListRequest>({
            query: ({ url, filter, size }) =>
                `${url}${objectToQueryParams({ filter, size, page: size === undefined ? undefined : 0 })}`,
        }),
    }),
});

export const { useGetSavedViewAnswerQuery } = APISavedViewFigureSlice;
